import { api } from '../api';

export const API_CHANNEL_HANDRAISING_PATH = '/channel/handraising';

export const notifyHandRaised = (studio) => api.post(
	API_CHANNEL_HANDRAISING_PATH,
	{ studio },
);
